export default "__VITE_ASSET__BPxBkYJC__"